import React from 'react';
import {Mixin as FormsyMixin} from 'formsy-react';
import ComponentMixin from 'formsy-react-components/release/mixins/component';
import {Row} from 'formsy-react-components';
import FormFields, { Field } from './FormFields.react';
import {declareEditEntity} from '../../common/fw/MetaDataHelper.ts';
import Immutable from 'immutable';
import TableDetail from '../fw/TableDetail.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { StorageAdapter } from '../utils/StorageAdapter.ts';
import SafeHTML from '../fw/SafeHTML.react';
import './SubForm.scss';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/prop-types */

const messages = defineMessages({
    add: {id: 'subForm.add', defaultMessage: 'Add'},
    edit: {id: 'subForm.edit', defaultMessage: 'Edit'},
    save: {id: 'subForm.save', defaultMessage: 'OK'},
});

let SubForm = React.createClass({
    displayName: 'SubForm',

    mixins: [FormsyMixin, ComponentMixin],

    getInitialState() {
        return {
            list: Immutable.List(),
            editedField: null,
        };
    },

    changeValue: function changeValue(key, item) {
        let values = this.getValue() || {};
        values[key] = item.value;
        this.setValue(values);
        this.props.onChange(this.props.name, values);
    },

    render: function render() {
        if (this.getLayout() === 'elementOnly') {
            return this.renderElement();
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            this.renderElement(),
            this.renderHelp(),
            this.renderErrorMessage()
        );
    },

    onClickAdd: function() {
        let list = this.getValue() || [];
        let idx = list.length;
        let newEntry = Immutable.Map({id: uuidv4()});
        let fields = (this.props.subForm ? this.props.subForm.columns : []) || [];

        for (let column of Object.keys(fields)) {
            if (fields[column] && 'defaultValue' in fields[column]) {
                let newValue;
                if (fields[column].defaultValue && typeof fields[column].defaultValue === "function") {
                    newValue = fields[column].defaultValue({});
                } else {
                    newValue = fields[column].defaultValue;
                }

                if (newValue !== undefined && newValue !== "") {
                    let propertyName = column.replace(this.props.columnPrefix + "[]_", "");
                    newEntry = newEntry.updateIn(propertyName.split("."), {}, (update) => {
                        update = newValue;
                        return update;
                    });
                }
            }
        }
        list.push(newEntry.toObject());

        let name = this.props.name;
        this.props.onChange(name, list);
        this.setValue(list);

        this.setState({
            editedField: idx,
            list: list,
        });
    },

    removeField: function (idx) {
        let list = this.getValue() || [];
        list.splice(idx, 1);

        let name = this.props.name;
        this.props.onChange(name, list);
        this.setValue(list);

        this.setState({
            list: list,
        });
    },

    editField: function (idx) {
        this.setState({
            editedField: idx,
        });
    },

    saveField: function (idx) {
        this.setState({
            editedField: null,
        });
    },

    handleStyleChange: function (style) {
        StorageAdapter.setSync('subFormStyle', style);
        this.setState({ formStyle: style });
    },

    getLocalStorageStyle: function () {
        return StorageAdapter.getSync('subFormStyle');
    },

    renderStyleSwitch(formStyle) {
        return (
            <div
                aria-label="Form Style Switch"
                className="form-style-switcher"
            >
                <div
                    className={`style-selector ${formStyle === 'editable' ? 'active' : ''}`}
                    onClick={() => this.handleStyleChange('editable')}
                    role="button"
                    tabIndex={0}
                >
                    <i className="fa fa-edit"></i>
                </div>

                <div
                    className={`style-selector ${formStyle === 'table' ? 'active' : ''}`}
                    onClick={() => this.handleStyleChange('table')}
                    role="button"
                    tabIndex={0}
                >
                    <i className="fa fa-table"></i>
                </div>

                <div
                    className={`style-selector ${formStyle === 'vertical' ? 'active' : ''}`}
                    onClick={() => this.handleStyleChange('vertical')}
                    role="button"
                    tabIndex={0}
                >
                    <i className="fa fa-align-justify"></i>
                </div>
            </div>
        );
    },

    /**
     * @override Select.renderElement
     */
    renderElement: function renderElement() {
        let htmlHelp = null;
        let help = null;

        if (this.props.htmlHelp) {
            htmlHelp = <span className="help-block"><SafeHTML value={this.props.htmlHelp + '<br/>'} /></span>;
        }

        if (this.props.help) {
                help = <span className="help-block">{this.props.help}</span>;
        }

        let columns = (this.props.subForm ? this.props.subForm.columns : []) || [];

        let values = this.getValue() || [];
        if (!Array.isArray(values)) {
            values = [values];
        }
        let metadata = declareEditEntity({
            entity: "options",
            graphQL: "Options",
            name: "",
            fields: (types) => {
                return columns;
            }
        });

        let className = "table table-striped table-condensed";

        let formStyle = this.props.subForm.formStyle;
        let component;

        if (formStyle === 'editable') {
            let columns2 = {};
            for (let column of Object.values(columns)) {
                columns2[column.fieldName] = column;
            }
            let metadata2 = declareEditEntity({
                entity: "options",
                graphQL: "Options",
                name: "",
                fields: (types) => {
                    return columns2;
                }
            });

            component = (

                <table className={className} style={{width: "100%"}} >
                    <tbody>
                        {values.map((item, idx) => {
                            let key = item['id'] || idx;
                            let value = item;

                            let editComponent;
                            let hasEditMode = false;
                            if (this.state.editedField != null && this.state.editedField === idx) {
                                hasEditMode = true;
                                editComponent = (<FormFields
                                        columnPrefix={this.props.columnPrefix ? (this.props.columnPrefix + "[]_") : (this.props.name + "[]_")}
                                        columnPrefixId={this.props.columnPrefixId ? (this.props.columnPrefixId + "." + idx) : (this.props.name + "." + idx)}
                                        columns={Object.keys(columns)}
                                        data={item}
                                        fetchingCache={this.props.fetchingCache}
                                        idx={"" + idx}
                                        metadata={metadata}
                                        onChange={(key, value) => this.changeValue(key, value)}
                                        onField={(column, addons) => {
                                            addons['onChange'] = (e, value) => {
                                                return this.props.setProperty(column, value);
                                            };

                                            return addons;
                                        }}
                                    >
                                    </FormFields>);
                            } else {
                                editComponent = (<TableDetail
                                    columns={Object.keys(columns2)}
                                    data={value}
                                    idx={"" + idx}
                                    metadata={metadata2}
                                >
                                </TableDetail>);

                            }

                            return (
                                <tr key={"row_" + key}>
                                    <td className="grid-field">
                                        <div style={{width: "100%"}}>
                                            {editComponent}

                                            {hasEditMode ? <div className="btn-toolbar" role="toolbar">
                                                <div className="btn-group" role="group">
                                                    <div className="btn btn-sm btn-default" onClick={() => this.saveField()}><span className="fa fa-edit"/> {this.props.intl.formatMessage(messages.save)}</div>
                                                </div>
                                            </div> : <div className="btn-toolbar" role="toolbar">
                                                <div className="btn-group" role="group">
                                                    <div className="btn btn-sm btn-default" onClick={() => this.editField(idx)}><span className="fa fa-edit"/> {this.props.intl.formatMessage(messages.edit)}</div>
                                                </div>
                                            </div>}
                                        </div>
                                    </td>
                                    <td key={idx + "_remove"} style={{'width': '40px'}}>
                                        <div className="btn btn-default btn-noborder" onClick={this.removeField.bind(this, idx)}><span className="fa fa-close" /></div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            );
        } else if (formStyle === 'vertical') {
            component = (

                <table className={className} style={{width: "100%"}}>
                    <tbody>
                        {values.map((item, idx) => {
                            let key = item['id'] || idx;
                            return (
                                <tr key={"row_" + key}>
                                    <td className="grid-field">
                                        <div style={{width: "100%"}}>
                                            <FormFields
                                                columnPrefix={this.props.columnPrefix ? (this.props.columnPrefix + "[]_") : (this.props.name + "[]_")}
                                                columnPrefixId={this.props.columnPrefixId ? (this.props.columnPrefixId + "." + idx) : (this.props.name + "." + idx)}
                                                columns={Object.keys(columns)}
                                                data={item}
                                                fetchingCache={this.props.fetchingCache}
                                                idx={"" + idx}
                                                metadata={metadata}
                                                onChange={(key, value) => this.changeValue(key, value)}
                                            >
                                            </FormFields>
                                        </div>
                                    </td>
                                    <td key={idx + "_remove"} style={{'width': '40px'}}>
                                        <div className="btn btn-default btn-noborder" onClick={this.removeField.bind(this, idx)}><span className="fa fa-close" /></div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            );
        } else {
            let hasAnyVisible = {};
            outer: for (let column of Object.keys(columns)) {
                hasAnyVisible[column] = true;
                if (!columns[column].visibility) {
                    hasAnyVisible[column] = true;
                    continue outer;
                }

                for (let row of values) {
                    if (columns[column].visibility(row)) {
                        hasAnyVisible[column] = true;
                        continue outer;
                    }
                }

                hasAnyVisible[column] = false;
            }

            let realColumns = {};
            for (let column of Object.keys(columns)) {
                if (hasAnyVisible[column]) {
                    realColumns[column] = columns[column];
                }
            }

            component = (

                <table className={className} style={{width: "100%"}}>
                    <thead>
                        <tr>
                            {Object.keys(realColumns).map((column) =>
                                <th key={"header_" + column} style={{"width": (100 / (Object.keys(realColumns).length)) + "%", "min-width": (100 / (Object.keys(realColumns).length * 2)) + "%"}}>{columns[column].name}</th>
                            )}
                            <th style={{'width': '40px'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {values.map((item, idx) => {
                            let key = item['id'] || idx;
                            return (
                                <FormFields
                                    columnPrefix={this.props.columnPrefix ? (this.props.columnPrefix + "[]_") : (this.props.name + "[]_")}
                                    columnPrefixId={this.props.columnPrefixId ? (this.props.columnPrefixId + "." + idx) : (this.props.name + "." + idx)}
                                    columns={Object.keys(realColumns)}
                                    data={item}
                                    fetchingCache={this.props.fetchingCache}
                                    idx={"" + idx}
                                    key={"row_" + key}
                                    metadata={metadata}
                                    onChange={(key, value) => this.changeValue(key, value)}
                                    useFloatingText={false}
                                >
                                    <tr>
                                        {Object.keys(realColumns).map((column) => {
                                            return (
                                                <td className="grid-field" key={idx + "_" + column}>
                                                    <Field column={column} extraArgs={columns[column]} />
                                                </td>
                                            );
                                        }
                                        )}
                                        <td key={idx + "_remove"}>
                                            <div className="btn btn-default btn-noborder" onClick={this.removeField.bind(this, idx)}><span className="fa fa-close" /></div>
                                        </td>
                                    </tr>
                                </FormFields>
                            );
                        })}
                    </tbody>
                </table>
            );
        }


        return (<div id={this.getId()}><div><small>{component}
                {this.props.children}

                <div className="btn-toolbar" role="toolbar">
                    <div className="btn-group" role="group">
                        <div className="btn btn-default" onClick={() => this.onClickAdd()}><span className="fa fa-plus"/> {(this.props.subForm?.operation || this.props.intl.formatMessage(messages.add))}</div>
                    </div>
                </div>
                </small></div>
            {help}{htmlHelp}</div>);

    }
});

export default injectIntl(SubForm);

